module.exports = __webpack_public_path__ + "static/media/import_product_detail.b456200f.png";